import { parseBig, QuoteService } from 'quote-domain-core';
import { PricingItemCommercialService } from '../pricing-item/pricing-item-commercial-service';
import { singleton } from 'tsyringe';

@singleton()
export class QuoteServiceRecommendedConsumableService {
    constructor(private readonly pricingItemCommercialService: PricingItemCommercialService) {
    }

    public calculate(quoteService: QuoteService, referential: any): void {
        const numberOfDaysOpen = parseBig(quoteService.contractInfoInputs?.openingDaysNbr?.split('/')[0]);
        const menEffectif = quoteService.contractInfoInputs?.menEffectif;
        const womenEffectif = quoteService.contractInfoInputs?.womenEffectif;
        const visitorEffectif = quoteService.contractInfoInputs?.visitorEffectif;
        const menAndWomenEffectif = quoteService.contractInfoInputs?.menAndWomenEffectif;

        (quoteService.customGroups ?? []).forEach(customGroup => {
            (customGroup.pricingItems ?? []).forEach(pricingItem => {
                this.pricingItemCommercialService.calculateRecommendedConsumableNumber(
                    pricingItem,
                    referential,
                    numberOfDaysOpen,
                    menEffectif,
                    womenEffectif,
                    visitorEffectif,
                    menAndWomenEffectif
                );
            });
        });
    }
}
